import { Link } from "react-router-dom";
import "../terms/terms.scoped.scss";

const Privacy = ({ lang }) => (lang === "PL" ? <PrivacyPL /> : <PrivacyEN />);

const PrivacyPL = () => {
	return (
		<div>
			<section className="big">
				<h1>Polityka Prywatności</h1>
				<p>Ostatnia aktualizacja Polityki Prywatności: 18 luty 2023</p>
				<p>Używając serwisu zgadzasz się na niniejszą politykę prywatności.</p>
			</section>

			<section>
				<h1>Informacje ogólne</h1>
				<ol>
					<li>
						Niniejsza polityka dotyczy Serwisu www, funkcjonującego pod adresem url:{" "}
						<b>wiktorgolicz.pl/AirlinesGroupManager</b>
					</li>
					<li>Operatorem serwisu oraz Administratorem danych osobowych jest: Wiktor Golicz </li>

					<li>
						Operator jest Administratorem Twoich danych osobowych w odniesieniu do danych podanych dobrowolnie w
						Serwisie.
					</li>
					<li>Serwis wykorzystuje dane osobowe w następujących celach:</li>
					<ul>
						<li>Weryfikacja użytkownika (logowanie)</li>
					</ul>
					<li>
						Serwis może realizować funkcje pozyskiwania informacji o użytkownikach i ich zachowaniu w następujący
						sposób:
						<ol>
							<li>
								Poprzez dobrowolnie wprowadzone w formularzach dane, które zostają wprowadzone do systemów
								Operatora.
							</li>
							<li>Poprzez zapisywanie w urządzeniach końcowych plików cookie (tzw. „ciasteczka”).</li>
						</ol>
					</li>
				</ol>
			</section>

			<section>
				<h1>Wybrane metody ochrony danych stosowane przez Operatora</h1>

				<p>
					Miejsca logowania i wprowadzania danych osobowych są chronione w warstwie transmisji (certyfikat SSL).
					Dzięki temu dane osobowe i dane logowania, wprowadzone na stronie, zostają zaszyfrowane w komputerze
					użytkownika i mogą być odczytane jedynie na docelowym serwerze.
				</p>

				<p>
					Hasła użytkowników są przechowywane w postaci hashowanej. Funkcja hashująca działa jednokierunkowo - nie
					jest możliwe odwrócenie jej działania, co stanowi obecnie współczesny standard w zakresie przechowywania
					haseł użytkowników.
				</p>
			</section>

			<section>
				<h1>Hosting</h1>

				<p>Serwis jest hostowany (technicznie utrzymywany) na serwerach operatora: lh.pl</p>
			</section>

			<section>
				<h1>Twoje prawa i dodatkowe informacje o sposobie wykorzystania danych</h1>

				<h2>Dodatkowe informacje o sposobie wykorzystania danych</h2>
				<p>
					W niektórych sytuacjach Administrator ma prawo przekazywać Twoje dane osobowe upoważnionym
					współpracownikom, którzy korzystają z danych w celu realizacji celu działania strony.
				</p>

				<p>
					Twoje dane osobowe przetwarzane przez Administratora nie dłużej, niż jest to konieczne do wykonania
					związanych z nimi czynności określonych osobnymi przepisami (np. o prowadzeniu rachunkowości). W
					odniesieniu do danych marketingowych dane nie będą przetwarzane dłużej niż przez 3 lata.
				</p>

				<h2>Twoje prawa</h2>
				<p>
					Przysługuje Ci prawo żądania od Administratora:
					<ul>
						<li>dostępu do danych osobowych Ciebie dotyczących,</li>
						<li>ich sprostowania,</li>
						<li>usunięcia,</li>
						<li>ograniczenia przetwarzania,</li>
						<li>oraz przenoszenia danych.</li>
					</ul>
				</p>

				<p>
					Przysługuje Ci prawo do złożenia żądania usunięcia twoich danych osobowych w celu wykonania prawnie
					uzasadnionych interesów realizowanych przez Administratora, w tym profilowania, przy czym prawo usunięcia
					nie będzie mogło być wykonane w przypadku istnienia ważnych prawnie uzasadnionych podstaw do
					przetwarzania, nadrzędnych wobec Ciebie interesów, praw i wolności, w szczególności ustalenia,
					dochodzenia lub obrony roszczeń. Po usunięciu danych, twoje prawo do korzystania z usługi natychmiast
					wygasa.
				</p>

				<p>
					Na działania Administratora przysługuje skarga do Prezesa Urzędu Ochrony Danych Osobowych, ul. Stawki 2,
					00-193 Warszawa.
				</p>

				<p>Podanie danych osobowych jest dobrowolne, lecz adres e-mail jest niezbędny do obsługi Serwisu.</p>

				<p>
					W stosunku do Ciebie mogą być podejmowane czynności polegające na zautomatyzowanym podejmowaniu decyzji,
					w tym profilowaniu w celu świadczenia usług w ramach zawartej umowy oraz w celu prowadzenia przez
					Administratora marketingu bezpośredniego.
				</p>

				<p>
					Dane osobowe nie są przekazywane od krajów trzecich w rozumieniu przepisów o ochronie danych osobowych.
					Oznacza to, że nie przesyłamy ich poza teren Unii Europejskiej.
				</p>
			</section>

			<section>
				<h1>Informacje w formularzach</h1>
				<ol>
					<li>
						Serwis może zbierać informacje podane dobrowolnie przez użytkownika, w tym dane osobowe, o ile
						zostaną one podane.
					</li>
					<li>Serwis może zapisać informacje o parametrach połączenia (oznaczenie czasu, adres IP).</li>
					<li>
						Serwis, w niektórych wypadkach, może zapisać informację ułatwiającą powiązanie danych w formularzu z
						adresem e-mail użytkownika wypełniającego formularz. W takim wypadku adres e-mail użytkownika pojawia
						się wewnątrz adresu url strony zawierającej formularz.
					</li>
					<li>
						Dane podane w formularzu są przetwarzane w celu wynikającym z funkcji konkretnego formularza, np. w
						celu dokonania procesu obsługi zgłoszenia serwisowego lub kontaktu handlowego, rejestracji usług itp.
						Każdorazowo kontekst i opis formularza w czytelny sposób informuje, do czego on służy.
					</li>
				</ol>
			</section>

			<section>
				<h1>Logi Administratora</h1>

				<p>
					Informacje zachowaniu użytkowników w serwisie mogą podlegać logowaniu. Dane te są wykorzystywane w celu
					administrowania serwisem.
				</p>
			</section>

			<section>
				<h1>Zapisywanie sesji użytkownika</h1>
				<p>
					Sesja użytkownika może być zapisywana poprzez serwis{" "}
					<a href="https://logrocket.com/" about="_blank">
						LogRocket
					</a>
					. Nagrywane i zapisywane mogą być w szczególności takie rzeczy jak:
					<ul>
						<li>Sposób korzystania z witryny</li>
						<li>Ruchy myszki</li>
						<li>Kliknięte linki</li>
						<li>
							Wpisany <strong>niewrażliwy</strong> tekst
						</li>
						<li>Używana przeglądarka i system operacyjny</li>
						<li>Pliki cookies</li>
					</ul>
					Wszystkie informacje i pełną listę zbieranych danych można zobaczyć{" "}
					<a href="https://logrocket.com/privacy/" about="_blank">
						tutaj
					</a>
					.
				</p>
			</section>

			<section>
				<h1>Istotne techniki marketingowe</h1>

				<p>
					Operator stosuje analizę statystyczną ruchu na stronie, poprzez Google Analytics (Google Inc. z siedzibą
					w USA). Operator nie przekazuje do operatora tej usługi danych osobowych, a jedynie zanonimizowane
					informacje. Usługa bazuje na wykorzystaniu ciasteczek w urządzeniu końcowym użytkownika. W zakresie
					informacji o preferencjach użytkownika gromadzonych przez sieć reklamową Google użytkownik może
					przeglądać i edytować informacje wynikające z plików cookies przy pomocy narzędzia:
					https://www.google.com/ads/preferences/
				</p>
				<p>
					Operator stosuje rozwiązanie automatyzujące działanie Serwisu w odniesieniu do użytkowników, np. mogące
					przesłać maila do użytkownika po odwiedzeniu konkretnej podstrony, o ile wyraził on zgodę na otrzymywanie
					korespondencji handlowej od Operatora.
				</p>
				<p>Operator może stosować profilowanie w rozumieniu przepisów o ochronie danych osobowych</p>
			</section>

			<section>
				<h1>Informacja o plikach cookies</h1>

				<p>
					Serwis korzysta z plików cookies.Pliki cookies (tzw. „ciasteczka”) stanowią dane informatyczne, w
					szczególności pliki tekstowe, które przechowywane są w urządzeniu końcowym Użytkownika Serwisu i
					przeznaczone są do korzystania ze stron internetowych Serwisu. Cookies zazwyczaj zawierają nazwę strony
					internetowej, z której pochodzą, czas przechowywania ich na urządzeniu końcowym oraz unikalny numer.
					Podmiotem zamieszczającym na urządzeniu końcowym Użytkownika Serwisu pliki cookies oraz uzyskującym do
					nich dostęp jest operator Serwisu.
				</p>

				<p>
					Pliki cookies są wykorzystywane lub mogą być wykorzystywane w następujących celach:
					<ul>
						<li>
							utrzymanie sesji użytkownika Serwisu (po zalogowaniu), dzięki której użytkownik nie musi na
							każdej podstronie Serwisu ponownie wpisywać loginu i hasła;
						</li>
						<li>realizacji celów określonych powyżej w części "Istotne techniki marketingowe";</li>
					</ul>
				</p>

				<p>
					W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików cookies: „sesyjne” (session cookies) oraz
					„stałe” (persistent cookies). Cookies „sesyjne” są plikami tymczasowymi, które przechowywane są w
					urządzeniu końcowym Użytkownika do czasu wylogowania, opuszczenia strony internetowej lub wyłączenia
					oprogramowania (przeglądarki internetowej). „Stałe” pliki cookies przechowywane są w urządzeniu końcowym
					Użytkownika przez czas określony w parametrach plików cookies lub do czasu ich usunięcia przez
					Użytkownika.
				</p>

				<p>
					Oprogramowanie do przeglądania stron internetowych (przeglądarka internetowa) zazwyczaj domyślnie
					dopuszcza przechowywanie plików cookies w urządzeniu końcowym Użytkownika. Użytkownicy Serwisu mogą
					dokonać zmiany ustawień w tym zakresie. Przeglądarka internetowa umożliwia usunięcie plików cookies.
					Możliwe jest także automatyczne blokowanie plików cookies Szczegółowe informacje na ten temat zawiera
					pomoc lub dokumentacja przeglądarki internetowej.
				</p>

				<p>
					Ograniczenia stosowania plików cookies mogą wpłynąć na niektóre funkcjonalności dostępne na stronach
					internetowych Serwisu.
				</p>

				<p>
					Pliki cookies zamieszczane w urządzeniu końcowym Użytkownika Serwisu wykorzystywane mogą być również
					przez współpracujące z operatorem Serwisu podmioty, w szczególności dotyczy to firm: Google (Google Inc.
					z siedzibą w USA), Facebook (Facebook Inc. z siedzibą w USA), Twitter (Twitter Inc. z siedzibą w USA).
				</p>
			</section>

			<section>
				<h1>Zarządzanie plikami cookies – jak w praktyce wyrażać i cofać zgodę?</h1>
				<p>
					Jeśli nie chcesz otrzymywać plików cookies, może zmienić ustawienia przeglądarki. Zastrzegamy, że
					wyłączenie obsługi plików cookies niezbędnych dla procesów uwierzytelniania, bezpieczeństwa, utrzymania
					preferencji użytkownika może utrudnić, a w skrajnych przypadkach może uniemożliwić korzystanie ze stron
					www
				</p>

				<p>
					W celu zarządzania ustawienia cookies wybierz z listy poniżej przeglądarkę internetową, której używasz i
					postępuj zgodnie z instrukcjami:
					<ul>
						<li>
							<a href="https://support.microsoft.com/pl-pl/help/10607/microsoft-edge-view-delete-browser-history">
								Edge
							</a>
						</li>
						<li>
							<a href="https://support.microsoft.com/pl-pl/help/278835/how-to-delete-cookie-files-in-internet-explorer">
								Internet Explorer
							</a>
						</li>
						<li>
							<a href="http://support.google.com/chrome/bin/answer.py?hl=pl&amp;answer=95647">Chrome</a>
						</li>
						<li>
							<a href="http://support.apple.com/kb/PH5042">Safari</a>
						</li>
						<li>
							<a href="http://support.mozilla.org/pl/kb/W%C5%82%C4%85czanie%20i%20wy%C5%82%C4%85czanie%20obs%C5%82ugi%20ciasteczek">
								Firefox
							</a>
						</li>
						<li>
							<a href="http://help.opera.com/Windows/12.10/pl/cookies.html">Opera</a>
						</li>
					</ul>
				</p>

				<p>
					Urządzenia mobilne:
					<ul>
						<li>
							<a href="http://support.google.com/chrome/bin/answer.py?hl=pl&amp;answer=95647">Android</a>
						</li>
						<li>
							<a href="http://support.apple.com/kb/HT1677?viewlocale=pl_PL">Safari (iOS)</a>
						</li>
						<li>
							<a href="http://www.windowsphone.com/pl-pl/how-to/wp7/web/changing-privacy-and-other-browser-settings">
								Windows Phone
							</a>
						</li>
					</ul>
				</p>
			</section>

			<section>
				<h1>Zmiany Polityki Prywatności</h1>
				<p>
					Zastrzegamy sobie prawo, według naszego wyłącznego uznania, do modyfikowania lub zastępowania niniejszej
					Polityki Prywatności w dowolnym momencie. W przypadku istotnych zmian, będziemy wymagać twej zgody na
					nowe warunki. Co stanowi istotną zmianę, zostanie ustalone według naszego wyłącznego uznania.
				</p>
				<p>
					Kontynuując dostęp do naszej Usługi lub korzystanie z niej po wejściu w życie wszelkich zmian, zgadzasz
					się na związanie się ze zmienioną polityką prywatności. Jeśli nie zgadzasz się na nowe warunki, w całości
					lub w części, zaprzestań korzystania z serwisu i Usługi.
				</p>
			</section>

			<section>
				<h1>Kontakt</h1>
				<p>
					Jeśli masz jakiekolwiek pytania dotyczące przetwarzania twoich danych skontaktuj się z nami:{" "}
					<a href="mailto: regulaminAGM@wiktorgolicz.pl">regulaminAGM@wiktorgolicz.pl</a>
				</p>
			</section>

			<footer>
				<small>Copyright &copy; {new Date().getFullYear()} Wiktor Golicz. Wszelkie prawa zastrzeżone.</small>
			</footer>
		</div>
	);
};

const PrivacyEN = () => {
	return (
		<div>
			Currently, the English version of the Privacy Policy is unavailable. You can view the original Polish version{" "}
			<Link to="/privacyPL">here</Link>
		</div>
	);
};

export default Privacy;
